import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { LinkDeviceWorkflow } from '../../devices/LinkDeviceWorkflow';

import AndroidTvImage from '../../../images/device-androidtv.png';
import CustomLink from '../../../components/CustomLink';

const useStyles = makeStyles((theme) => ({
  pageHeading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  deviceOverview: {
    paddingTop: 20,

    '& img': {
      width: '100%',
      height: 'auto'
    }
  },
  deviceImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export const AndroidTvConnector = ({ screen, onCancel }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container>
      <Grid container>
        <Grid item xs={2}>
          <ArrowBack onClick={onCancel} />
        </Grid>
        <Grid item xs={8} className={classes.pageHeading}>
          {t('AndroidTv.ConnectAndroidTv')}
        </Grid>
        <Grid container item xs={12} className={classes.deviceOverview} spacing={2}>
          <Grid item xs={3} className={classes.deviceImage}>
            <img alt="Android TV" src={AndroidTvImage} />
          </Grid>
          <Grid item xs={9}>
            <Typography variant="h2">{t('AndroidTv.AndroidTvReady')}</Typography>
            <p>
              {t('AndroidTv.Download')}{' '}
              <CustomLink href="https://play.google.com/store/apps/details?id=com.pourwall.firetv" target="_blank">
                {t('AndroidTv.PourwallAndroidTv')}
              </CustomLink>{' '}
              {t('AndroidTv.App')}
            </p>
            <p style={{ opacity: 0.8 }}>
              {t('AndroidTv.ScreenOff')} {t('AndroidTv.GoTo')} <em>{t('AndroidTv.Settings')}</em> &gt;{' '}
              <em>
                {t('AndroidTv.Display')} &amp; {t('AndroidTv.Sounds')}
              </em>{' '}
              &gt; <em>{t('AndroidTv.ScreenSaver')}</em>. {t('AndroidTv.Select')} <u>{t('AndroidTv.Never')}</u> {t('AndroidTv.Under')}{' '}
              <em>{t('AndroidTv.StartTime')}</em>.
            </p>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 20 }}>
          <LinkDeviceWorkflow screen={screen} />
        </Grid>
      </Grid>
    </Grid>
  );
};
